var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5C10.5 3.96875 10.9375 3.5 11.5 3.5C12.0312 3.5 12.5 3.96875 12.5 4.5C12.5 5.0625 12.0312 5.5 11.5 5.5C10.9375 5.5 10.5 5.0625 10.5 4.5ZM10.5 11C10.1875 11 9.90625 11 9.625 10.9375L8.75 11.7812C8.625 11.9375 8.4375 12 8.25 12H7V13.25C7 13.6875 6.65625 14 6.25 14H5V15.25C5 15.6875 4.65625 16 4.25 16H0.75C0.3125 16 0 15.6875 0 15.25V11.75C0 11.5625 0.0625 11.375 0.21875 11.2188L5.0625 6.375C5 6.09375 5 5.8125 5 5.5C5 2.46875 7.4375 0 10.5 0C13.5312 0 16 2.46875 16 5.5C16 8.5625 13.5312 11 10.5 11ZM10.5 9.5C12.6875 9.5 14.5 7.71875 14.5 5.5C14.5 3.3125 12.6875 1.5 10.5 1.5C8.28125 1.5 6.5 3.3125 6.5 5.5C6.5 5.71875 6.5 5.9375 6.53125 6.15625L6.65625 6.90625L1.46875 12.0625V14.5H3.46875V12.5H5.46875V10.5H7.9375L9.09375 9.34375L9.84375 9.46875C10.0625 9.5 10.2812 9.5 10.5 9.5Z",
    fill: "#989CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.0e59a90e3696f319859a5d0a93148c8a.svg";
export { ForwardRef as ReactComponent };